import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "@gemini/ui";
import { useTrackingLeadInterestPhone, useCustomerAction, useCallWithReturnRequestCallback, } from "@/hooks";
import { PhoneIcon } from "@gemini/icons";
import { useEffect, useState } from "react";
import { useContactSections } from "@/contexts/contact";
import { MobilePhonesModal } from "@/components/contacting/MobilePhonesModal";
import { RequestCallbackModal } from "@/components/contacting/RequestCallbackModal";
import { useCallTracking, useCallTrackingRequest, } from "@/contexts/callTracking/hooks";
import { useConfig } from "@/contexts/cdpConfig";
import { useTrackingLegacyLeadEvents } from "@/hooks/tracking/trackingLegacy";
import { useClassified } from "@/contexts/classified";
import { useClassifiedAnalytics } from "@/hooks/tracking/classifiedAnalytics";
import { CA_EVENT_TYPES } from "@/types/classifiedAnalytics";
export const PhoneButton = ({ trackingAvZone, legacyTrackingInfos, rootTestId, isFullWidth, children, displayPhoneNumbers, iconOnly, onPress, variant = "secondary", size, }) => {
    var _a, _b;
    const trackLeadPhoneInterestEvent = useTrackingLeadInterestPhone(trackingAvZone);
    const { sendClassifiedAnalyticsEvent } = useClassifiedAnalytics();
    const { legacyLeadConversionPhone } = useTrackingLegacyLeadEvents(); //legacy GA3 for harvest
    const { fetchCallTrackingData, numberMappings, isCallTrackingRequestDone } = useCallTracking();
    const { customerActionExposeContactPhoneView, customerActionExposeContactPhoneCall, } = useCustomerAction();
    const options = useCallTrackingRequest();
    const legacyTrackingData = (_a = useClassified()) === null || _a === void 0 ? void 0 : _a.legacyTracking;
    const isPreviewMode = useConfig().previewMode;
    const { phoneNumbers = [] } = (_b = useContactSections().contactCard) !== null && _b !== void 0 ? _b : {};
    const [isCalltrackingLoading, setIsCalltrackingLoading] = useState(false);
    const [doNativeCall, setDoNativeCall] = useState(false);
    const hasLegacyTrackingData = !!legacyTrackingData;
    // Hook to handle native call + return callback
    const [isRequestCallbackModalOpen, setIsRequestCallbackModalOpen] = useState(false);
    const onCallReturn = useCallWithReturnRequestCallback(() => {
        setIsRequestCallbackModalOpen(true);
    });
    const onPressDisplayPhoneNumbers = async () => {
        trackLeadPhoneInterestEvent();
        sendClassifiedAnalyticsEvent(CA_EVENT_TYPES.PHONE_NUMBER_DISPLAY);
        if (hasLegacyTrackingData) {
            legacyLeadConversionPhone({
                eventData: { infos: legacyTrackingInfos },
            });
        }
        customerActionExposeContactPhoneView();
        if (!isCallTrackingRequestDone) {
            fetchCallTrackingData(options);
            setIsCalltrackingLoading(true);
        }
        onPress === null || onPress === void 0 ? void 0 : onPress();
    };
    const onPressCallNumber = async (phoneNumber) => {
        if (typeof window === "undefined" || !phoneNumber)
            return;
        customerActionExposeContactPhoneView();
        customerActionExposeContactPhoneCall();
        trackLeadPhoneInterestEvent();
        if (hasLegacyTrackingData) {
            legacyLeadConversionPhone({
                eventData: { infos: legacyTrackingInfos },
            });
        }
        if (!isCallTrackingRequestDone) {
            fetchCallTrackingData(options);
            setIsCalltrackingLoading(true);
            setDoNativeCall(true);
        }
        else {
            onCallReturn(phoneNumber);
        }
    };
    // Once call tracking data arrives, dial via onCallReturn
    useEffect(() => {
        var _a;
        setIsCalltrackingLoading(false);
        if (doNativeCall) {
            const callNum = ((_a = numberMappings[0]) === null || _a === void 0 ? void 0 : _a.virtualPhoneNumber) || phoneNumbers[0];
            onCallReturn(callNum);
            setDoNativeCall(false);
        }
    }, [doNativeCall, numberMappings, onCallReturn, phoneNumbers]);
    const getButtonSize = (iconOnly, size) => {
        if (size)
            return size;
        if (iconOnly)
            return "40";
    };
    const buttonSize = getButtonSize(iconOnly, size);
    return (_jsxs(_Fragment, { children: [_jsx(Button, { iconOnly: iconOnly, size: buttonSize, isFullWidth: isFullWidth, testId: `${rootTestId}.PhoneButton`, variant: variant, iconPosition: "start", icon: PhoneIcon, onPress: () => displayPhoneNumbers
                    ? onPressDisplayPhoneNumbers()
                    : onPressCallNumber(phoneNumbers[0]), isLoading: isCalltrackingLoading, isDisabled: isPreviewMode, children: children }), _jsx(RequestCallbackModal, { isOpen: isRequestCallbackModalOpen, setIsOpen: setIsRequestCallbackModalOpen })] }));
};
const PhoneModalButton = ({ trackingAvZone, legacyTrackingInfos, rootTestId, children, variant = "secondary", }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    return (_jsxs(_Fragment, { children: [_jsx(PhoneButton, { onPress: () => setIsModalOpen(true), isFullWidth: true, trackingAvZone: trackingAvZone, legacyTrackingInfos: legacyTrackingInfos, rootTestId: rootTestId, displayPhoneNumbers: true, variant: variant, children: children }), _jsx(MobilePhonesModal, { onOpenChange: setIsModalOpen, isOpen: isModalOpen })] }));
};
export const PhoneCTA = ({ trackingAvZone, legacyTrackingInfos, rootTestId, children, phoneNumbers, variant = "secondary", iconOnly, size, showModal = false, }) => {
    const hasMultiplePhoneNumbers = (phoneNumbers === null || phoneNumbers === void 0 ? void 0 : phoneNumbers.length) > 1;
    const hasNoPhoneNumbers = (phoneNumbers === null || phoneNumbers === void 0 ? void 0 : phoneNumbers.length) === 0;
    if (hasNoPhoneNumbers)
        return null;
    return (_jsx(_Fragment, { children: hasMultiplePhoneNumbers || showModal ? (_jsx(PhoneModalButton, { rootTestId: rootTestId, trackingAvZone: trackingAvZone, legacyTrackingInfos: legacyTrackingInfos, variant: variant, iconOnly: iconOnly, size: size, children: children })) : (_jsx(PhoneButton, { isFullWidth: true, trackingAvZone: trackingAvZone, legacyTrackingInfos: legacyTrackingInfos, rootTestId: rootTestId, variant: variant, iconOnly: iconOnly, size: size, children: children })) }));
};
